/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface AppSchemasAuthMFAVerifyRequest {
  /**
     * @minLength 6
     * @maxLength 6
     * @pattern ^\d{6}$
     */
  code: string;
  /** @maxLength 1000 */
  pending_authentication_token: string;
  /** @maxLength 255 */
  authentication_challenge_id: string;
  comet_token?: string | null;
}
